<template>
    <div id="gallery">
        <div v-if="error" class="container mtb-80">
            <app-back :title="error"></app-back>
        </div>

        <div v-if="gallery">
            <h1 class="title has-text-centered mtb-80 is-size-1" >Galerija slik</h1>
                <div class="mtb-20">
                    <form id="search" autocomplete="off" @submit.stop.prevent="submitPrevent($event)">
                        <input class="input searchInput" id="searchField" name="query" v-model="query" placeholder="Išči ..." @keyup="itemFilter">
                        <span v-if="query !==''" @click="clear" class="is-icon">
                            <i class="close">X</i>
                        </span>
                    </form>
                    <p class="has-text-danger has-text-right" :class="errorClass" v-if="searchError">Filter slike {{ query }}: {{ gallery.error | lowercase }} </p>
                </div>
                <app-pagination :pagination="pagination" :endpoint="componentEndpoint" @click.native="getResults(pagination.current_page)" :offset="4">
                </app-pagination>
                <!-- static albumId for gallery -->
                <app-sb :photos="gallery.photos.data" albumId="photo-gallery" class="full-page"></app-sb>

                <app-pagination :endpoint="componentEndpoint" :pagination="pagination" @click.native="getResults(pagination.current_page)" :offset="4">
                </app-pagination>
        </div>
    </div>
</template>

<script>
import { ApiHome, PhotoUrl, baseUrl } from '../../.env';
import { mapGetters, mapActions } from 'vuex';
import StringsMixin from '../../mixins/StringsMixin';
import HeaderBar from '../../components/layout/HeaderBar.vue';
import BackButton from '../../components/layout/BackButton.vue';
import Silentbox from '../../components/elements/silentbox/Silentbox.vue';
import Pagination from '../../components/elements/pagination/Pagination.vue';

export default {
    props: ['page'],
    mixins: [StringsMixin],

    data() {
        // console.log(this.page, this.p);
        return {
            endpoint: ApiHome+ 'gallery',
            endpointSearch: ApiHome + 'searchGallery',
            photoUrl: PhotoUrl,
            query: '',
            errorClass: '',
            size: '/1960/',
        }
    },

    components: {
        'app-header': HeaderBar,
        'app-sb': Silentbox,
        'app-back': BackButton,
        'app-pagination': Pagination,
    },

    computed: {
        ...mapGetters([
            'gallery',
            'loading',
            'error',
            'title',
            'paginate',
            'pagination',
        ]),

        imagePath() {
            // console.log('image path: ', PhotoUrl);
            return PhotoUrl + this.gallery.album_id + this.size;
        },

        galleryPhotos() {
            // console.log('gallery photos: ', this.gallery.photos);
            return this.gallery.photos;
        },

        componentEndpoint() {
            return '/galerija/p';
        },

        searchError() {
            if(this.query !== '' && this.gallery.error && this.gallery.error !== '') {
                console.log(' error for filters ');
                this.errorClass = '';
                return true;
            }
            this.errorClass = 'is-hidden';
            return false;
        }
    },

    methods: {
        /**
         * get paginated results - for page > 1
         * paginate - navigation click
         */
        getResults(page) {
            if (typeof page === 'undefined') {
                page = 2;
            }
            // let endpoint = this.endpoint;

            page = this.page;
            let endpoint = this.endpoint + '/p/' + page;

            let data = {
                endpoint: endpoint,
                page: this.page,
                type: 'gallery',
            };
            // console.log('gallery getResults: ', endpoint, ' page: ', page, 'this.page: ', this.page);
            this.$store.dispatch('getPaginatedItems', data);
        },

        fetchAlbumPhotos() {
            let endpoint = this.endpoint;

            let page = this.page;
            if(typeof(this.page) === 'undefined') {
                // console.log('PAGE undefined');
                page = 1;
            }

            let data = {
                endpoint: endpoint,
                page: page,
                type: 'gallery',
                album: '',
            };

            endpoint = this.endpoint + '/p/' + page;
            data.endpoint = endpoint;

            // console.log('PAGE undefined? ', data);
            this.$store.dispatch('fetchGallery', data);
        },

        clear() {
            this.query = '';
            this.$store.dispatch('clearNotification');
            this.$store.dispatch('clearError');
            this.fetchAlbumPhotos();
        },

        submitPrevent(event) {
            // console.log('prevent submit: ', event);
            event.stopPropagation();
            event.preventDefault();
            // return false;
        },

        /**
         * live search
         */
        itemFilter() {
            let self=this;
            if(self.query === '') {
                // console.log('empty query, page: ', this.page);
                // this.fetchPhoto();
                this.fetchAlbumPhotos();
            }
            else {
                let first = 'name';
                let second = 'description';
                let third = '';

                // if(this.link === '/photos/') {
                    first = 'name';
                    second = 'album_id';
                    third = 'location_id';
                // }
                this.endpoint = this.endpointSearch;
                let data = {
                    field: [first,second],
                    value: self.query,
                    endpoint: this.endpoint
                };

                this.$store.dispatch('fetchGalleryFilter', data);
            }
        },
    },

    created() {
        this.itemFilter();
        // document.title = this.capitalize(this.photo);
        // console.log('Gallery - Component mounted.')
    }
}
</script>





// WEBPACK FOOTER //
// src/views/gallery/Gallery.vue